import moment from 'moment'
import InvoiceUtil from './../invoice/libs/util';
// ../libs/util

export function getPaymentType(paymentType) {
    if (paymentType === undefined || !Array.isArray(paymentType)) return ""
    return paymentType.filter(type => [0, 1].includes(type)).map(type => {
        if ([0, 1].includes(type)) return ["报销", "付款"][type]
        return "-"
    }).join(',')
}

export const invoice_table_headers = [
    {
        text: '详情',
        value: 'id',
        align: 'center',
        class: 'fixed',
        cellClass: 'fixed',
        width: 40,
        sortable: false
    },
    {
        text: '发票代码',
        value: 'code',
        align: 'center',
        class: 'fixed',
        cellClass: 'fixed',
        width: 100,
        sortable: false
    },
    {
        text: '发票号码',
        value: 'uid',
        align: 'center',
        class: 'fixed',
        cellClass: 'fixed',
        width: 70,
        sortable: false
    },
    {
        text: "付款类型",
        value: "payment_type",
        align: 'center',
        width: 70,
        sortable: false
    },
    {
        text: '发票类型',
        value: 'invoice_type',
        align: 'center',
        width: 70,
        sortable: false
    },
    {
        text: '发票形态',
        value: 'invoice_form',
        align: 'center',
        width: 70,
        sortable: false
    },
    {
        text: '总价',
        value: 'total_price',
        align: 'center',
        width: 90,
        sortable: false
    },
    {
        text: '税前总价',
        value: 'pretax_price',
        align: 'center',
        width: 90,
        sortable: false
    },
    {
        text: '税额',
        value: 'tax',
        align: 'center',
        width: 90,
        sortable: false
    },
    {
        text: '综合税率%',
        value: 'tax_rate',
        align: 'center',
        width: 80,
        sortable: false
    },
    {
        text: '已分配金额',
        value: 'give_price',
        align: 'center',
        width: 80,
        sortable: false
    },
    {
        text: '开票时间',
        value: 'invoice_date',
        align: 'center',
        width: 80,
        sortable: false
    },
    {
        text: '认证月份',
        value: 'use_month',
        align: 'center',
        width: 70,
        sortable: false
    },
    {
        text: '发票文件',
        value: 'invoice_file_id',
        align: 'center',
        width: 70,
        sortable: false
    },
    {
        text: '校验码',
        value: 'check_code',
        align: 'center',
        width: 150,
        sortable: false
    },
    {
        text: '销售方',
        value: 'seller',
        align: 'center',
        width: 160,
        sortable: false
    },
    {
        text: '购买方',
        value: 'buyer',
        align: 'center',
        width: 180,
        sortable: false
    },
    {
        text: '申请人',
        value: 'apply_customer_name',
        align: 'center',
        width: 180,
        sortable: false
    },
    {
        text: '经办人',
        value: 'fill_customer_name',
        align: 'center',
        width: 180,
        sortable: false
    },
    {
        text: '备注',
        value: 'remark',
        align: 'center',
        width: 120,
        sortable: false
    },
    {
        text: '录入时间',
        value: 'created_at',
        align: 'center',
        width: 80,
        sortable: false
    },
    {
        text: '验真状态',
        value: 'validation',
        align: 'center',
        class: 'fixed fixed-right',
        cellClass: 'fixed fixed-right',
        width: 80,
        sortable: false
    },
    {
        text: '审核状态',
        value: 'audited',
        align: 'center',
        class: 'fixed fixed-right',
        cellClass: 'fixed fixed-right',
        width: 80,
        sortable: false
    },
    {
        text: '操作',
        value: 'operate',
        align: 'center',
        class: 'fixed fixed-right',
        cellClass: 'fixed fixed-right',
        width: 180,
        sortable: false
    }
]
export const invoice_status_fields = [
    {
        title:'所有验真状态',
        value: 'all'
    },
    {
        title:'未验真',
        value: '未验真'
    },
    {
        title:'验真成功',
        value: '验真成功',
        class:"color-success"
    },
    {
        title:'验真失败',
        value: '验真失败',
        class:"color-error"
    },
    {
        title:'信息不一致',
        value: '信息不一致',
        class:"color-error"
    },
    {
        title:'参数错误',
        value: '参数错误',
        class:"color-warning"
    },
    {
        title:'其他错误',
        value: '其他错误',
        class:"color-warning"
    }
]


export const invoice_date_fields = [
    {
        title:'时间升序',
        value: 'asc'
    },
    {
        title:'时间降序',
        value: 'desc'
    }
]
export const audit_status_fields = [
    {
        title:'所有审核状态',
        value: 'all'
    },
    {
        title:'未审核',
        value: 'unaudited'
    },
    {
        title:'已审核',
        value: 'has_audited'
    },
    {
        title:'处理中',
        value: 'processing'
    },
    {
        title:'已归档',
        value: 'archived'
    }
]

export const audit_status_hash = audit_status_fields.reduce((t, i) => {
    t[i.value] = i
    return t
}, {})

export const print_table_fields = [
    {
        title: '序列号',
        key: '_index',
    },
    {
        title: '录入时间',
        key: 'created_at',
        render(row) {
            return row.created_at ? moment(row.created_at).format('YYYY-MM-DD') : ''
        }
    },
    {
        title: '开票时日期',
        key: 'invoice_date',
        render(row) {
            return row.invoice_date ? moment(row.invoice_date).format('YYYY-MM-DD') : ''
        }
    },
    {
        title: '购买方',
        key: 'buyer',
    },
    {
        title: '销售方',
        key: 'seller',
    },
    {
        title: '申请人',
        key: 'apply_customer_name',
    },
    {
        title: '经办人',
        key: 'fill_customer_name',
    },
    {
        title: '发票类型',
        key: 'invoice_type',
        render(row) {
         return row.invoice_type !== undefined ? InvoiceUtil.getInvoiceType(row.invoice_type) : '';
        }
    },
    {
        title: '发票形态',
        key: 'invoice_form',
        render(row) {
            let str = '-'
            switch (row.invoice_form) {
                case 'electronic':
                    str = '电子'
                    break;
                case 'paper':
                    str = '纸质'
                    break;
                
                default:
                    break;
            }
            return str
        }
    },
    {
        title: '发票代码',
        key: 'code',
    },
    {
        title: '发票号码',
        key: 'uid',
    },
    {
        title: '总金额', 
        key: 'total_price',
    },
    {
        title: '不含税金额', 
        key: 'pretax_price',
    },
    {
        title: '税额', 
        key: 'tax',
    },
    {
        title: '已分配金额', 
        key: 'give_price',
    },
    {
        title: '认证月份',
        key: 'use_month',
        render(row) {
            return row.use_month ? moment(row.use_month).format('YYYY-MM-DD') : ''
        }
    },

    {
        title: '关联单据号',
        key: 'expense_groups_uid',
    },
    {
        title: '关联金额',
        key: 'expense_groups_allot_price',
    },
    {
        title: '关联税额',
        key: 'expense_groups_allot_tax',
    },
]

export const payment_type = [
    {
        title: '全部付款类型',
        value:'all',
        _val: ''
    },
    {
        title: '报销',
        value: 'dispatch',
        _val: true
    },
    {
        title: '非报销',
        value: 'unDispatch',
        _val: false
    },
]